module.exports = __webpack_public_path__ + "img/koala.563ff650.png";